import moment from 'moment';

export const dateToString = (date) => {
  if (date == null) { return null; }
  var days = ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "​​Lørdag"];
  var curr_date = date.getDate();
  var curr_month = date.getMonth() + 1;
  var curr_year = date.getFullYear();
  return days[date.getDay()] + " d." + curr_date + "/" + curr_month + "/" + curr_year;
}

export const dateToStringNoDays = (date) => {
  var curr_date = date.getDate();
  var curr_month = date.getMonth() + 1;
  var curr_year = date.getFullYear();
  return curr_date + "/" + curr_month + " " + curr_year;
}

export const dateToStringWithMonth = (date) => {
  if (date == null) { return null; }
  var months = getMonths()
  var curr_date = date.getDate();
  var curr_month = date.getMonth();
  var curr_year = date.getFullYear();
  return curr_date + " " + months[curr_month] + " " + curr_year;
}

export const dateToStringWithMonth2 = (date) => {
  if (date == null) { return null; }
  var months = getMonths()
  var curr_date = date.getDate();
  var curr_month = date.getMonth();
  var curr_year = date.getFullYear();
  return curr_date + ". " + months[curr_month] + " " + curr_year;
}

export const dateMonthAndYear = (date) => {
  if (date == null) { return null; }
  var months = getMonths()
  var curr_month = date.getMonth();
  var curr_year = date.getFullYear();
  return months[curr_month] + " " + curr_year;
}

export const getFullDateString = (date, isShortenedMonrths) => {
  if (date == null) { return null; }
  var months = getMonths(isShortenedMonrths)
  var days = ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "​​Lørdag"];
  var curr_date = date.getDate();
  var curr_month = date.getMonth();
  var curr_year = date.getFullYear();
  return days[date.getDay()] + " d. " + curr_date + " " + months[curr_month] + " " + curr_year;
}

function getMonths(isShortened) {
  if (isShortened)
    return ["Jan.", "Feb.", "Mar.", "Apr.", "Maj", "Jun.", "Jul.", "Aug.", "Sep.", "Okt.", "Nov.", "Dec."];
  else
    return ["Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December"];
}

export const simpleDate = (date) => {
  if (date == null) { return null; }
  var curr_date = date.getDate();
  var curr_month = ("0" + (date.getMonth() + 1)).slice(-2);
  var curr_year = date.getFullYear();
  return curr_date + "/" + curr_month + "/" + curr_year;
}

export const daysDiff = (date, date2) => {
  if (date2 == null) { date2 = new Date() }
  return (date - date2) / (1000 * 24 * 60 * 60);
}

export const getWeeknumber = date => {
  if (date == null) { return null; }
  var temp = new Date(date);
  return moment(temp).isoWeek();
}

export const getDates = date => {
  if (date == null) { return null; }
  var copyD = new Date(date);
  var res = {
    mon: { date: null, label: 'MAN' },
    tue: { date: null, label: 'TIR' },
    wed: { date: null, label: 'ONS' },
    thu: { date: null, label: 'TORS' },
    fri: { date: null, label: 'FRE' },
    sat: { date: null, label: 'LØR' },
    sun: { date: null, label: 'SØN' }
  }
  //if date is Sunday, reset one week back
  if (copyD.getDay() === 0) { copyD.setDate(copyD.getDate() - 7); }
  res.mon.date = new Date(copyD.setDate(copyD.getDate() - copyD.getDay() + 1));
  res.tue.date = new Date(copyD.setDate(copyD.getDate() - copyD.getDay() + 2));
  res.wed.date = new Date(copyD.setDate(copyD.getDate() - copyD.getDay() + 3));
  res.thu.date = new Date(copyD.setDate(copyD.getDate() - copyD.getDay() + 4));
  res.fri.date = new Date(copyD.setDate(copyD.getDate() - copyD.getDay() + 5));
  res.sat.date = new Date(copyD.setDate(copyD.getDate() - copyD.getDay() + 6));
  res.sun.date = new Date(copyD.setDate(copyD.getDate() - copyD.getDay() + 7));

  return res;
}

export const addDays = (date, days) => {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export const isDatesSameDay = (date1, date2) => {
  return date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
}

// Source: http://stackoverflow.com/questions/497790
export const dates = {
  convert: function (d) {
    // Converts the date in d to a date-object. The input can be:
    //   a date object: returned without modification
    //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
    //   a number     : Interpreted as number of milliseconds
    //                  since 1 Jan 1970 (a timestamp)
    //   a string     : Any format supported by the javascript engine, like
    //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
    //  an object     : Interpreted as an object with year, month and date
    //                  attributes.  **NOTE** month is 0-11.
    return (
      d.constructor === Date ? d :
        d.constructor === Array ? new Date(d[0], d[1], d[2]) :
          d.constructor === Number ? new Date(d) :
            d.constructor === String ? new Date(d) :
              typeof d === "object" ? new Date(d.year, d.month, d.date) :
                NaN
    );
  },
  compare: function (a, b) {
    // Compare two dates (could be of any type supported by the convert
    // function above) and returns:
    //  -1 : if a < b
    //   0 : if a = b
    //   1 : if a > b
    // NaN : if a or b is an illegal date
    // NOTE: The code inside isFinite does an assignment (=).
    return (
      isFinite(a === this.convert(a).valueOf()) &&
        isFinite(b === this.convert(b).valueOf()) ?
        (a > b) - (a < b) :
        NaN
    );
  },
  inRange: function (d, start, end) {
    // Checks if date in d is between dates in start and end.
    // Returns a boolean or NaN:
    //    true  : if d is between start and end (inclusive)
    //    false : if d is before start or after end
    //    NaN   : if one or more of the dates is illegal.
    // NOTE: The code inside isFinite does an assignment (=).
    return (
      isFinite(d === this.convert(d).valueOf()) &&
        isFinite(start === this.convert(start).valueOf()) &&
        isFinite(end === this.convert(end).valueOf()) ?
        start <= d && d <= end :
        NaN
    );
  }
}


// WEBPACK FOOTER //
// ./src/App/Util/dateTime.js